import { Translate, I18n } from 'react-redux-i18n';

import store from 'app/store'
import { ACTION_PERMISSIONS, ADMIN, MANAGER, SUPPORT, SUPPORT_ADMIN } from 'app/constants';
import { STEPS, STEP_GROUPS } from 'endpoints/dashboard';

import { SupportConfiguration } from './components';

const buildPermissionMap = (list) => {
  let result = list.reduce((acc, item) => {
    acc[item.key] = item.level;
    return acc;
  }, {});
  STEPS.concat(ACTION_PERMISSIONS).forEach((key) => {
    if (!result.hasOwnProperty(key)) {
      result[key] = 0;
    }
  });
  return result;
};

const toFormValue = (permissions) =>
  Object.keys(permissions).reduce((acc, key) => {
    let level = permissions[key];
    if (level !== 0) {
      acc.push({ key, level });
    }
    return acc;
  }, []);

export default class extends React.Component {
  constructor({ value }) {
    super();
    this.state = { permissions: buildPermissionMap(value) };
  }

  onContentPermissionChange(key, e) {
    this.onPermissionChange(key, parseInt(e.target.value));
  }

  onActionPermissionChange(key, e) {
    this.onPermissionChange(key, e.target.checked ? 4 : 0);
  }

  onPermissionChange(key, level) {
    let permissions = { ...this.state.permissions, [key]: level };
    this.setState({ permissions });
    this.props.onChange(toFormValue(permissions));
  }

  render() {
    switch (this.props.role) {
      case ADMIN:
        return (
          <div className="alert alert-info py-4">
            <Translate value="users.admin_permissions" />
          </div>
        );
      case SUPPORT:
        return <SupportConfiguration/>;
      case SUPPORT_ADMIN:
        const { data: { roles } } = store.getState();
        const { description } = roles.find(item => item.name === SUPPORT_ADMIN);
        return (
          <div className="alert alert-info py-4">
            <span>{description}</span>
          </div>
        );
      case MANAGER:
      default: {
        const contentPermissionOptions = [
          <option key="disabled" value={0}>
            {I18n.t('enums.permission_level.disabled')}
          </option>,
          <option key="read" value={1}>
            {I18n.t('enums.permission_level.read')}
          </option>,
          <option key="full" value={3}>
            {I18n.t('enums.permission_level.read_write')}
          </option>,
        ];

        let stepPermissions = Object.keys(STEP_GROUPS).map((group) => {
          let colPrefix = 3 < STEP_GROUPS[group].length ? '-4 mb-2' : '';
          let steps = STEP_GROUPS[group].map((key) => {
            return (
              <div key={key} className={`col${colPrefix}`}>
                <label key="label" className="small">
                  <Translate
                    value={`enums.permission.${key.toLocaleLowerCase()}`}
                  />
                </label>
                <select
                  key="input"
                  value={this.state.permissions[key]}
                  onChange={this.onContentPermissionChange.bind(this, key)}
                  className="form-control"
                >
                  {contentPermissionOptions}
                </select>
              </div>
            );
          });
          return (
            <div
              key={group}
              className={`col-${steps.length <= 3 ? 6 : 12} mb-4 d-flex`}
            >
              <div className="card align-self-stretch w-100">
                <div className="card-header">
                  <Translate value={`enums.step_group.${group}`} />
                </div>
                <div className="card-body row align-items-end">{steps}</div>
              </div>
            </div>
          );
        });

        let actionPermissions = ACTION_PERMISSIONS.map((key) => (
          <div key={key} className="form-check mb-4">
            <label className="form-check-label">
              <input
                type="checkbox"
                onChange={this.onActionPermissionChange.bind(this, key)}
                checked={this.state.permissions[key] !== 0}
                className="form-check-input"
              />
              <Translate
                value={`enums.permission.${key.toLocaleLowerCase()}`}
                className="small"
              />
            </label>
          </div>
        ));

        return (
          <div className="form-group">
            <label>
              <Translate value="attrs.permissions" />
            </label>
            {actionPermissions}
            <div className="row align-items-stretch">{stepPermissions}</div>
          </div>
        );
      }
    }
  }
}
